import Validator from "~/config/validation/validators/Validator";
import ValidationError from "~/config/validation/ValidationError";
import {betterTypeOf} from "~/config/validation/validators/util";
import {isFunction} from "~/util/misc";

export default class FuncValidator extends Validator {
    /**
     * @param {any} value
     * @param {string|undefined} path
     * @return {function}
     */
    validate(value, path = undefined) {
        if (value === undefined && this.defaultValue !== undefined) {
            return this.validate(this.defaultValue, path);
        } else if (isFunction(value)) {
            return value;
        } else {
            throw new ValidationError(path, `Expected a function, but got ${betterTypeOf(value)}`);
        }
    }
}
